import { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ColorRing } from 'react-loader-spinner'
import { ClearSession } from '../../Common/Common'
import { Link } from 'react-router-dom';

import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const UploadDataReportTable = ({ loading, currentPageNo, handleChange, setColoredRow, ColoredRow, tableData, handleClick  }) => {

    //const [type, setType] = useState('')
    //const [pageIndex, setPageIndex] = useState('')
    const [SessionClear, SetSessionClear] = useState(false);



  
    const handleHighlight = (id) => {
        setColoredRow(id)
    }
    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(tableData.pageSize)))

    useEffect(() => {
       
    }, [])


    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading mt-3">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                      
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.length !== 0 ?
                                                    (
                                                        tableData?.totalRecord !== null ?
                                                            ( <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                        <th>{tableData.hqrCode}</th>
                                                                        <th>{tableData.htrunkid}</th>
                                                                        <th>{tableData.hevent}</th>
                                                                        <th>{tableData.hvenue}</th>
                                                                        <th>{tableData.hcustodian}</th>
                                                                        <th>{tableData.hcsC_REPRESETATIVE}</th>
                                                                        <th>{tableData.hdistrict}</th>
                                                                        <th>{tableData.hcsC_REPMOBILE}</th>
                                                                        <th>{tableData.hcustodiaN_EMAILID}</th>
                                                                        <th>{tableData.hdM_EMAIL}</th>
                                                                        <th>{tableData.hdrivermobile}</th>
                                                                        <th>{tableData.hvehicleid}</th>
                                                                        <th>{tableData.hvehiclenumber}</th>
                                                                        <th>{tableData.hvenuE_CONTACT_PERSON}</th>
                                                                        <th>{tableData.hvenuE_EMAIL}</th>
                                                                        <th>{tableData.hvenuE_MOBILE}</th>
                                                                        <th>{tableData.hcreatedby}</th>
                                                                        <th>{tableData.hcreateddate}</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                    {tableData?.getUploadData !== null ?
                                                                    (
                                                                            (tableData?.getUploadData)?.map((uploadData, index) => (
                                                                                <tr key={index} className="tablerow" onClick={() => handleHighlight(uploadData)} style={{ background: uploadData === ColoredRow ? '#cbe2ff' : '' }} >
                                                                                    <td>

                                                                                        <Link style={{ cursor: 'pointer' }} to={`/QrCode#data:image/png;base64,${uploadData.qrCode}`} target="_blank">
                                                                                            <i className="fa fa-qrcode" style={{ fontSize: "19px", marginLeft: "23px" }}></i>
                                                                                        </Link>
                                                                                    </td>
                                                                                    <td><Link onClick={() => { handleClick(uploadData.trunK_ID) }}>
                                                                                        {uploadData.trunK_ID}</Link>
                                                                                    </td>
                                                                                <td>{uploadData.event}</td>
                                                                                <td>{uploadData.venue}</td>
                                                                                    <td>{uploadData.custodian}</td>
                                                                                    <td>{uploadData.csC_REPRESETATIVE}</td>
                                                                                   
                                                                                    <td>{uploadData.district}</td>
                                                                                    <td>{uploadData.csC_REPMOBILE}</td>
                                                                                    <td>{uploadData.custodiaN_EMAILID}</td>
                                                                                    <td>{uploadData.dM_EMAIL}</td>
                                                                                    <td>{uploadData.drivermobile}</td>
                                                                                    <td>{uploadData.vehicleid}</td>
                                                                                    <td>{uploadData.vehiclenumber}</td>
                                                                                    <td>{uploadData.venuE_CONTACT_PERSON}</td>
                                                                                    <td>{uploadData.venuE_EMAIL}</td>
                                                                                    <td>{uploadData.venuE_MOBILE}</td>
                                                                                    <td>{uploadData.createdby}</td>
                                                                                    <td>{uploadData.createddate}</td>
                                                                                  	
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<></>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                        <Pagination count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange} shape="rounded" />

                                                : ''}
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center'>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                                {SessionClear ? <ClearSession /> : <></>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}
export default UploadDataReportTable;
